import { Context } from "csi/def/Context";
import Heading from "csi/def/Heading";
import Number from "csi/heading/Number";
import { C8Node } from "csi/typings";
import declare from "dojo/_base/declare";

const CALCULATED: string = "LabelItemCalculationStatus:Calculated";

const IngredientContributorPctOfLevel = declare(Number, {
	/**
	* @override
	* Return PriceChange for view
	*/
	toValue(ctx: Context, h: Heading) {
		// IngredientItemContributor
		const node: C8Node = ctx.getNode();
		const ingItem: C8Node = ctx.cache.get(node.IngredientItem);
		const parentNode: C8Node = ctx.cache.get(node.__Parent__);

		const level = node?.Level;
		const parentPctOfLevel: number = parentNode?.PctOfLevel ?? 1;
		
		const bomItemPctOfLevel: number = node?.BOMLineItemPctOfLevel ?? 1;
		const ingItemRelQty: number = node?.RelativeQty ?? 1;
		const ingItemCalcFromRelQty: number = node?.CalcFromRelativeQty ?? 1;
		const ingItemCalcPct: number = node?.CalculatedPct ?? 1;

		// store the PctOfLevel value on IngredientItemContributor to be used on levels 2+
		node.PctOfLevel = parentPctOfLevel * (level === 0 ? 1: bomItemPctOfLevel);

		const calculated = ingItem?.CalculationStatus === CALCULATED || ingItemCalcPct !== 0.0 || ingItemCalcFromRelQty !== 0.0;

		const pctOfLevel: number = node.PctOfLevel * (calculated ? ingItemCalcPct : ingItemRelQty);

		return this.formatValue(pctOfLevel, "0.00%");
	},
});
export = IngredientContributorPctOfLevel;